import { Navigate } from 'react-router-dom';
import { useOrgPaths } from '@/hooks/useOrgPaths';

/** Legacy `/inventory-hires` → unified court hire bookings tab. */
export function OrgInventoryHiresRedirect() {
  const { p } = useOrgPaths();
  const target = p('/court-hire/bookings');
  if (!target) return null;
  return <Navigate to={target} replace />;
}
